import { isGroup, mapStateToLayoutProps, rankWith } from '@jsonforms/core';
import { html, repeat, when } from '@microsoft/fast-element';
import { LAYOUT_GROUP_RANK } from './RenderersRanks';
export const LayoutGroupRendererTemplate = html `
  <template>
    <div>
      ${when((x) => x.control.label, html `
          <div
            for="${(x) => x.control.path + '-wrapper'}"
            style="color: rgb(135, 155, 166);
                   margin-bottom: 4px;
                   display: flex;
                   justify-content: space-between;"
          >
            ${(x) => x.control.label}
          </div>
        `)}
      ${repeat((x) => x.control.uischema.options.childElements, html `
          <dispatch-renderer
            ?submitted=${(x, ctx) => ctx.parent.submitted}
            :dispatch=${(x, ctx) => ctx.parent.dispatch}
            :jsonforms=${(x, ctx) => ctx.parent.jsonforms}
            :props=${(x, ctx) => ({
    uischema: x,
    schema: ctx.parent.control.schema,
    renderers: ctx.parent.control.renderers,
    path: ctx.parent.control.path,
    enabled: ctx.parent.control.enabled,
})}
          ></dispatch-renderer>
        `)}
    </div>
  </template>
`;
export const LayoutGroupRendererEntry = {
    renderer: LayoutGroupRendererTemplate,
    tester: rankWith(LAYOUT_GROUP_RANK, isGroup),
    mapper: mapStateToLayoutProps,
};
